<script lang="ts">
  import Icon from "./Icon.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import { createEventDispatcher } from "svelte";

  import type { ActionBarCardTrackingEvent } from "@shared/types/ActionBarCard";

  export let titleText: string = undefined;
  export let icon: string = undefined;
  export let iconFill: string = undefined;
  export let actionText: string = undefined;
  export let actionLink: string = undefined;
  export let trackingEvent: ActionBarCardTrackingEvent = undefined;
  export let iconWidth: number = 16;
  export let iconHeight: number = 16;
  export let targetObjectType: string = "";
  export let useTrackClick: boolean = false;
  export let cardHeaderPadding: string = "fizz-stack-4";

  const dispatch = createEventDispatcher();

  const onActionClick = () => {
    dispatch("actionClick");
  };

  $: {
    trackingEvent.params = trackingEvent.params;
    trackingEvent = trackingEvent;
  }
</script>

<style>
  .card-header {
    max-height: 18px;
  }

  .action-bar-card {
    height: 162px;
    min-width: 450px;
  }

  @media (max-width: 1024px) {
    .action-bar-card {
      height: 162px;
      min-width: 309px;
    }
  }

  @media (max-width: 700px) {
    .action-bar-card {
      height: 162px;
      min-width: 280px;
    }
  }
</style>

<div
  class="fizz-card fizz-bordered fizz-third-width fizz-text-center fizz-inset-square-12 action-bar-card"
>
  <div class={`card-header fizz-space-between fizz-inset-horizontal-8 ${cardHeaderPadding}`}>
    <div class="fizz-flex-row-4">
      {#if iconFill}
        <Icon width={iconWidth} height={iconHeight} type={icon} fill={iconFill} />
      {:else}
        <Icon width={iconWidth} height={iconHeight} type={icon} />
      {/if}
      <p class="fizz-text-small fizz-text-strong fizz-text-brand">{titleText}</p>
    </div>
    <div>
      {#if trackingEvent}
        {#key trackingEvent}
          <UIRouterLink
            stateName={trackingEvent.stateName}
            eventName={trackingEvent.eventName}
            trackingParams={trackingEvent.trackingParams}
            params={trackingEvent.params}
            classes={"fizz-text-small fizz-text-strong"}
            {targetObjectType}
            {useTrackClick}
          >
            {actionText}
          </UIRouterLink>
        {/key}
      {:else if actionText}
        <!-- svelte-ignore a11y-missing-attribute -->
        <a
          href={actionLink}
          on:click={onActionClick}
          class="fizz-text-small fizz-text-strong cursor-pointer"
        >
          {actionText}
        </a>
      {/if}
    </div>
  </div>
  <slot name="body" />
</div>
